import { morph } from '@theme/morph';
import { Component } from '@theme/component';
import { StandardEvents, ProductSelectEvent } from '@shopify/events';

/**
 * A custom element that displays a variant's rich text metafield.
 * It listens for variant change events and re-renders itself from the freshly
 * fetched product HTML, mirroring the pattern used by product-inventory.
 */
class VariantMetafieldTextBlock extends Component {
  connectedCallback() {
    super.connectedCallback();
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.addEventListener(StandardEvents.productSelect, this.#handleProductSelect);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.removeEventListener(StandardEvents.productSelect, this.#handleProductSelect);
  }

  /**
   * Handles product select event by updating the metafield text.
   * @param {ProductSelectEvent} event - The product select event.
   */
  #handleProductSelect = (event) => {
    if (!(event.target instanceof Element) || event.target.closest('product-card')) return;

    event.promise
      .then(({ detail }) => {
        if (!detail?.html) return;

        const { html, newProduct } = detail;

        if (newProduct) {
          this.dataset.productId = newProduct.id;
        } else if (detail.productId && detail.productId !== this.dataset.productId) {
          return;
        }

        const blockId = this.dataset.blockId;
        const selector = blockId
          ? `variant-metafield-text-block[data-block-id="${blockId}"]`
          : 'variant-metafield-text-block';
        const newBlock = html.querySelector(selector);
        if (!newBlock) return;

        morph(this, newBlock, { childrenOnly: true });
      })
      .catch((error) => {
        if (error?.name !== 'AbortError') console.warn('[variant-metafield-text] Event promise rejected:', error);
      });
  };
}

if (!customElements.get('variant-metafield-text-block')) {
  customElements.define('variant-metafield-text-block', VariantMetafieldTextBlock);
}
